import { createReducer } from '@sde/widgets-core/src/redux/helpers/createReducer';
import { SET_PAYER } from './constants';

const initialState = {
  payerId: '',
  payerName: '',
  payerLabel: '',
};

export const payerReducer = createReducer(initialState, {
  [SET_PAYER]: (state, action) => {
    return action.payload;
  },
});
